<template>
    <div class="app my-app">
        <scroll class="" @refresh="refresh">
            <div v-show="rechargeList.length > 0" class="text-center row small f-small f-minor">
                此卡近三个月的充值记录
            </div>
            <no-record :condition="rechargeList" :tips="'抱歉，没有充值记录！'"></no-record>
            <section :id="'myPay-payItem-' + index" class="thick" v-for="(recharge, index) in rechargeList" :key="index">
                <div class="content charge-list">
                    <span class="">订单号：&nbsp;&nbsp;&nbsp;&nbsp;</span><span class="">{{recharge.tranSerNo}}</span>
                </div>
                <div class="content charge-list">
                    <span class="f-minor">充值时间：&nbsp;&nbsp;{{recharge.operateTime | formatpayDate}}</span>
                    <span class="fr f-strongest">{{recharge.amount | formatFee}}</span>
                </div>
            </section>
        </scroll>
    </div>
</template>
<script>
    import NoRecord from 'NoRecord'
    import queryFun from 'queryFunList.service'

    export default {
        components: {
            NoRecord,
        },
        data() {
            return {
                postParam:{},
                rechargeList: [],
                noRecord: false,
                utils: this.$utils
            };
        },
        mounted() {

        },
        created() {
            const params = {
                orgId: http.headers.common['organizationId'],
                hospitalId: http.headers.common['hospitalId'],
                inPatientNo: this.$store.state.paramModule.param.myRecharge.queryParam.inPatientNo,
                startDate: "",
                endDate: "",
            }
            this.loadMyPayList(params);
        },
        methods: {
            refresh() {
                this.postParam = this.$store.state.paramModule.param.myRecharge.queryParam;
            },
            loadMyPayList(params) {
                this.rechargeList = [];
                this.noRecord = true;
                queryFun.getRechargeList(params).then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS || res.data.length <= 0) {
                        this.noRecord = true;
                        this.rechargeList = [];
                        this.$utils.alert(res.resultMsg);
                        return;
                    }
                    this.rechargeList = res.data;
                });
            },
        },
        watch: {
            rechargeList(val) {
                if (val.length === 0) {
                    this.noRecord = true;
                } else {
                    this.noRecord = false;
                }
            }
        }
    }
</script>
<style lang="scss">
    .my-app {
        background-color: #eff2f5;
        .charge-list {
            border-bottom: 1px solid #e9e9e9;

            .fr {
                float: right;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// MyRecharge.vue?68f198b0